import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getAssetsList,getAssetsInfoByProductidAPI } from 'components/assets/AssetsAPI';
import { setAssetsList, setAssetsDashboardAssetsList } from 'store/slice/ManufSlice';
import AssetsDashboard from '../AssetsDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function AssetsPageImpl() {
    const dispatch = useDispatch();
    const { assetsList} = useSelector((state)=>state.manufslice);
    const {mfproductObj}= useSelector((state)=>state.manufslice.mfproductDashboard);
    
    useEffect(() => {
        getAssetsInfoByProductidAPI(mfproductObj.id, ()=>{}, (list) => {
            dispatch(setAssetsList(list));
        });
    },[]);
   
    return (
        < AssetsDashboard />
    )

}